import { render, staticRenderFns } from "./HomeBodyThird.vue?vue&type=template&id=20f61afe&scoped=true"
import script from "./HomeBodyThird.vue?vue&type=script&lang=js"
export * from "./HomeBodyThird.vue?vue&type=script&lang=js"
import style0 from "./HomeBodyThird.vue?vue&type=style&index=0&id=20f61afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f61afe",
  null
  
)

export default component.exports